export enum Separator{
  pipe = 0,
  colon = 1,
  semicolon = 2,
  comma = 3,
  dot = 4,
  space = 5,
  slash = 6,
  dash = 7,
  underscore = 8,
  equals = 9,
  percent = 10
  //backslash = 6
}
export class SeparatorUtil {
  static toString(separator: Separator): string {
      switch (separator) {
        case Separator.pipe: return '| (pipe)';
        case Separator.colon: return ': (colon)';
        case Separator.semicolon: return '; (semicolon)';
        case Separator.comma: return ', (comma)';
        case Separator.dot: return '. (dot/period)';
        case Separator.space: return '" " (space)';
        case Separator.slash: return '/ (fwd slash)';
        case Separator.dash: return '- (dash)';
        case Separator.underscore: return '_ (underscore)';
        case Separator.equals: return '= (equals)';
        case Separator.percent: return '% (percent)';
        //case Separator.backslash: return '\ (back slash)';
      }
  }
}
export class SeparatorValue {
  static toString(separator: Separator): string {
      switch (separator) {
        case Separator.pipe: return '|';
        case Separator.colon: return ':';
        case Separator.semicolon: return ';';
        case Separator.comma: return ',';
        case Separator.dot: return '.';
        case Separator.space: return ' ';
        case Separator.slash: return '/';
        case Separator.dash: return '-';
        case Separator.underscore: return '_';
        case Separator.equals: return '=';
        case Separator.percent: return '%';
        //case Separator.backslash: return '\ (back slash)';
      }
  }
}

export const separatorOptions = Object.values(Separator)
  .filter(value => typeof value === 'number') // filter enum keys
  .map(value => ({
    text: SeparatorUtil.toString(value as Separator),
    value: SeparatorValue.toString(value as Separator)
  }));

export enum SeparatorNone{
  none = 0,
  pipe = 1,
  colon = 2,
  semicolon = 3,
  comma = 4,
  commaSpace = 5,
  dot = 6,
  space = 7,
  slash = 8,
  dash = 9,
  underscore = 10
}
export class SeparatorNoneUtil {
  static toString(separator: SeparatorNone): string {
    switch (separator) {
      case SeparatorNone.none: return '(none)';
      case SeparatorNone.pipe: return '| (pipe)';
      case SeparatorNone.colon: return ': (colon)';
      case SeparatorNone.semicolon: return '; (semicolon)';
      case SeparatorNone.comma: return ', (comma)';
      case SeparatorNone.commaSpace: return ', (comma/space)';
      case SeparatorNone.dot: return '. (dot/period)';
      case SeparatorNone.space: return '" " (space)';
      case SeparatorNone.slash: return '/ (fwd slash)';
      case SeparatorNone.dash: return '- (dash)';
      case SeparatorNone.underscore: return '_ (underscore)';
    }
  }
}
export class SeparatorNoneValue {
  static toString(separator: SeparatorNone): string {
    switch (separator) {
      case SeparatorNone.none: return '';
      case SeparatorNone.pipe: return '|';
      case SeparatorNone.colon: return ':';
      case SeparatorNone.semicolon: return ';';
      case SeparatorNone.comma: return ',';
      case SeparatorNone.commaSpace: return ', ';
      case SeparatorNone.dot: return '.';
      case SeparatorNone.space: return ' ';
      case SeparatorNone.slash: return '/';
      case SeparatorNone.dash: return '-';
      case SeparatorNone.underscore: return '_';
    }
  }
}

export const SeparatorNoneOptions = Object.values(SeparatorNone)
  .filter(value => typeof value === 'number') // filter enum keys
  .map(value => ({
    text: SeparatorNoneUtil.toString(value as SeparatorNone),
    value: SeparatorNoneValue.toString(value as SeparatorNone)
  }));
